module.exports = __webpack_public_path__ + "static/media/may-queen.44333b7f.md";